import { InfoIcon } from "../../icons/InfoIcon";
import { withBaseButton } from "./BaseButton";

const InfoButton = withBaseButton(InfoIcon);

export { InfoButton };
